import React, { useState } from 'react';
import { HiArrowSmUp, HiOutlineArrowDown } from 'react-icons/hi';
import Pagination from 'react-pagination-js';

const Table = ({
  className = '',
  data = [],
  columns = [],
  topHead = [],
  count = 50,
  total = 0,
  page = 1,
  result = (e) => {},
  nodata = 'No Data',
}) => {
  const [pageSize, setPageSize] = useState(count);
  const handlePaginate = (e) => {
    console.log('e', e);
    result({ event: 'page', value: e });
  };
  const view = (row) => {
    result({ event: 'row', row: row });
  };

  const headclick = (itm) => {
    if (itm.sort) {
      result({ event: 'sort', value: itm.key });
    }
  };
  const handlePageSizeChange = (e) => {
    setPageSize(parseInt(e.target.value));
    result({ event: 'count', value: parseInt(e.target.value) });
  };
  const generateOptions = () => {
    const options = [];
    for (let i = 10; i <= total; i += 10) {
      options.push(i);
    }
    return options;
  };
  return (
    <>
      <div className={`${className}`}>
        {/* {total ? ( */}
        <>
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead className="border-b border-[#EAECF0] text-xs text-gray-700  capitalize bg-gray-50 ">
                {topHead?.length ? (
                  <>
                    <tr className="border-b border-[#EAECF0]">
                      {topHead?.map((itm, i) => {
                        return (
                          <>
                            <th
                              scope="col"
                              className={`px-6 py-3  ${
                                topHead.length - 1 == i
                                  ? ''
                                  : 'border-r border-black capitalize'
                              }`}
                              colSpan={itm?.colSpan || 0}
                              key={i}
                            >
                              {itm.name}
                            </th>
                          </>
                        );
                      })}
                    </tr>
                  </>
                ) : (
                  <></>
                )}
                <tr>
                  {columns.map((itm) => {
                    return (
                      <>
                        <th
                          scope="col"
                          className={`px-6 py-3 ${
                            itm?.isLeft ? '' : 'text-center'
                          } capitalize ${itm.sort ? 'cursor-pointer' : ''}`}
                          onClick={() => headclick(itm)}
                          key={itm.key}
                        >
                          {itm.name}{' '}
                          {itm?.sort ? (
                            <span className="ml-2">
                              {itm?.filters?.sortBy == `${itm?.key} asc` ? (
                                <HiArrowSmUp className="shrink-0 inline text-sm" />
                              ) : (
                                <HiOutlineArrowDown className="shrink-0 inline text-sm" />
                              )}
                            </span>
                          ) : null}
                        </th>
                      </>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {data.map((itm) => {
                  return (
                    <>
                      <tr
                        className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                        key={itm.id}
                      >
                        {columns.map((citm, i) => {
                          return (
                            <>
                              <td
                                className={`!text-typo !border-l-0 cursor-pointer !px-3.5 text-sm font-normal !py-2 !border ${
                                  i == 0 ? 'text-left' : 'text-center'
                                } border-[#EAECF0]`}
                              >
                                {citm.render(itm) || '--'}
                              </td>
                            </>
                          );
                        })}
                      </tr>
                    </>
                  );
                })}
              </tbody>
            </table>
          </div>
        </>
        {/* ) : (
          <>
            <div className="p-4 text-center">{nodata}</div>
          </>
        )} */}

        {count < total ? (
          <>
            <div className="paginationWrapper flex items-center justify-between mt-15">
              {/* <span>Show {count} from {total} data</span> */}
              <select
                value={pageSize}
                onChange={handlePageSizeChange}
                className="border rounded-md px-2 py-1"
              >
                {/* Dynamically generated options */}
                {generateOptions().map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>{' '}
              <Pagination
                currentPage={page}
                totalSize={total}
                sizePerPage={count}
                changeCurrentPage={handlePaginate}
              />
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default Table;
